import React, { useEffect, useMemo, useState } from "react";
import { Card, CardBody, CardHeader, Col, Input, Row } from "reactstrap";
import { isEmpty } from "lodash";
import TableContainer from "../../../../Components/Common/TableContainer";

import { useDispatch, useSelector } from "react-redux";

import HandleDateTime from "../../../../Components/Common/HandleDateTime";

import NoDataContent from "../../../../Components/Common/NoDataContent";
import { getCompanyTeamMembersList } from "../../../../store/companyToUser/action";
import LoadingSpinner from "../../../../Components/Common/Spinner";
import SettingsPanel from "../../components/SettingsPanel";

export default function TeamMembers() {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const { companyTeamMembersList, companyTeamMembersListLoading } = useSelector(
    (state) => ({
      companyTeamMembersList:
        state.CompanyToUser.companyTeamMembersList?.companytouser_list,
      companyTeamMembersListLoading:
        state.CompanyToUser.companyTeamMembersListLoading,
    })
  );

  useEffect(() => {
    dispatch(getCompanyTeamMembersList());
  }, []);

  const columns = useMemo(
    () => [
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "User_Id",
        filterable: false,
        Cell: (card) => (
          <>
            <span> #{card.row.original?.User_Id}</span>
          </>
        ),
      },
      {
        Header: "Full Name",
        accessor: "User_UserFullName",
        filterable: true,
        Cell: (card) => <>{card.row.original?.User_UserFullName || ""}</>,
      },
      {
        Header: "Email",
        accessor: "User_Email",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        Cell: (card) => {
          return (
            <div>
              <span className={""}>{card.row.original?.User_Email}</span>
            </div>
          );
        },
        filterable: false,
      },
    ],
    []
  );
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Id",
    "companyTeamMembersList",
    "User_UserLastName",
    "User_Email",
    "SubscriptionProduct_Name",
  ]);
  useEffect(() => {
    let filteredCustomerList = companyTeamMembersList;

    const timer = setTimeout(() => {
      filteredCustomerList = filteredCustomerList?.filter((item) => {
        return allowedSearchFilters.some((key) => {
          return (
            item[key] &&
            item[key].toString().toLowerCase().includes(search?.toLowerCase())
          );
        });
      });

      setSearchResults(filteredCustomerList);
    }, 300);
    return () => clearTimeout(timer);
  }, [search, companyTeamMembersList]);

  const [modalAddCustomerCard, setModalAddCustomerCard] = useState(false);
  const toggleAddCustomerCard = () =>
    setModalAddCustomerCard(!modalAddCustomerCard);
  // Stripe Starts Here
  const [clientSecret, setClientSecret] = useState("");
  const authUser = JSON?.parse(localStorage?.getItem("authUser"));

  return (
    <SettingsPanel
      title="Team Members"
      description="People with access to this company"
    >
      <Row>
        <Col lg={12}>
          <Card id="customersList">
            <CardHeader className="border-0">
              <Row className="g-4 align-items-center">
                <Col sm={3}>
                  <div className="search-box">
                    <Input
                      // create search with jobs List Data
                      type="search"
                      className="form-control search"
                      placeholder="Search for..."
                      onChange={(e) => setSearch(e.target.value)}
                      value={search}
                    />
                    <i className="ri-search-line search-icon"></i>
                  </div>
                </Col>
                <div className="col-sm-auto ms-auto">
                  <div className="hstack gap-2"></div>
                </div>
              </Row>
            </CardHeader>
            <CardBody className="pt-0">
              {companyTeamMembersListLoading ? (
                <LoadingSpinner />
              ) : (
                <div>
                  {!isEmpty(companyTeamMembersList) ? (
                    <TableContainer
                      columns={columns}
                      data={searchResults || []}
                      isGlobalFilter={false}
                      isAddUserList={false}
                      customPageSize={10}
                      className="custom-header-css"
                      divClass="table-responsive table-card mb-0"
                      tableClass="align-middle table-nowrap"
                      theadClass="text-muted"
                      // handleLeadClick={handleLeadClicks}
                      isLeadsFilter={false}
                    />
                  ) : (
                    <NoDataContent
                      titleText={`Your Team members list is empty.`}
                      paragraphText={`Get started by inviting your first team member.`}
                      useButton={true}
                      buttonOnClick={() => {}}
                      buttonText={"Invite Team Member"}
                    />
                  )}
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </SettingsPanel>
  );
}
